export const initialState = {
  products: [],
  isFetching: false,
}

export const setProducts = (state, payload) => (
  { ...state, products: payload, isFetching: false }
)

export const setFetchStatus = (state, payload) => (
  { ...state, isFetching: payload }
)

export const reset = () => initialState
